import React from "react"
import { CollapsableContainer } from "@ciq/shared/components/collapsable"
import { formatNumber } from "@ciq/shared/utils/format"

export function FlowDetails({ details, onClose }) {
  if (!details) return null

  return (
    <CollapsableContainer header={details.buildingName} onClose={onClose}>
      <div className="flow-details__totals">
        <div className="flow-details__total flow-details__total--inflow">
          <span className="flow-details__total-label">Inflow</span>
          <span className="flow-details__total-value">{formatNumber(details.inflow)}</span>
        </div>
        <div className="flow-details__total flow-details__total--outflow">
          <span className="flow-details__total-label">Outflow</span>
          <span className="flow-details__total-value">{formatNumber(details.outflow)}</span>
        </div>
      </div>

      {details.topArrivals.length > 0 && (
        <div className="flow-details__list">
          <span className="flow-details__list-title">Top Arrivals</span>
          {details.topArrivals.map((item, i) => (
            <div key={i} className="flow-details__list-item">
              <span>{item.name}</span>
              <span>{formatNumber(item.volume)}</span>
            </div>
          ))}
        </div>
      )}

      {details.topDepartures.length > 0 && (
        <div className="flow-details__list">
          <span className="flow-details__list-title">Top Departures</span>
          {details.topDepartures.map((item, i) => (
            <div key={i} className="flow-details__list-item">
              <span>{item.name}</span>
              <span>{formatNumber(item.volume)}</span>
            </div>
          ))}
        </div>
      )}
    </CollapsableContainer>
  )
}
